import { COMPANY_NAME_PATTERN, EMAIL_PATTERN, NAME_PATTERN, PASSWORD_PATTERN } from "./patterns";

export const VALIDATION_SCHEMA = {
  login: {
    required: "E-mail is required",
  },
  email: {
    required: "E-mail is required",
    pattern: {
      value: EMAIL_PATTERN,
      message: "Please provide a valid e-mail",
    },
  },
  password: {
    required: "Please specify a password",
    pattern: {
      value: PASSWORD_PATTERN,
      message:
        "Password must include at least one uppercase and lowercase character, one digit and one of the special symbols",
    },
    minLength: {
      value: 8,
      message: "Min length is 8 characters",
    },
  },
  passwordConfirmation: {
    required: "Please specify a password confirmation",
    pattern: {
      value: PASSWORD_PATTERN,
      message:
        "Password confirmation must include at least one uppercase and lowercase character, one digit and one of the special symbols",
    },
    minLength: {
      value: 8,
      message: "Min length is 8 characters",
    },
  },
  firstName: {
    required: "Please enter First name",
    pattern: {
      value: NAME_PATTERN,
      message: "First name is incorrect",
    },
  },
  lastName: {
    required: "Please enter Last name",
    pattern: {
      value: NAME_PATTERN,
      message: "First name is incorrect",
    },
  },
  companyName: {
    pattern: {
      value: COMPANY_NAME_PATTERN,
      message: "Company name is incorrect",
    },
  },
  country: {
    required: "Please select a country",
  },
  city: {
    required: "Please enter your city",
  },
  phone: {
    required: "Please enter the phone number",
    minLength: {
      value: 8,
      message: "Min length with country code is 8 characters",
    },
  },
  verificationCode: {
    required: "Authentication code is required",
  },
};
